import {
  LEASING_DOCUMENTS_AVAILABLE_STAGES,
  LEASING_REQUEST_STAGE_ORDER,
  WAITING_OF_FINANCING_STATUS_CODE
} from '@/shared/constants/leasing-request-stages';
import type { TRequestStage } from '@/shared/types/leasing-request.types';

interface IDocumentsAvailabilityRequest {
  stage: TRequestStage;
  statusCode?: string;
}

export const isDocumentsAvailable = (
  request: IDocumentsAvailabilityRequest
): boolean => {
  if (request.statusCode === WAITING_OF_FINANCING_STATUS_CODE) {
    return true;
  }

  return LEASING_DOCUMENTS_AVAILABLE_STAGES.includes(request.stage);
};

export const getNextLeasingRequestStage = (
  currentStage: TRequestStage
): TRequestStage => {
  if (currentStage === 'contract') {
    return 'contract';
  }

  const currentStageIndex = LEASING_REQUEST_STAGE_ORDER.indexOf(currentStage);

  if (currentStageIndex === -1) {
    return 'decision';
  }

  if (currentStageIndex >= LEASING_REQUEST_STAGE_ORDER.length - 1) {
    return 'contract';
  }

  return LEASING_REQUEST_STAGE_ORDER[currentStageIndex + 1];
};

export const getLeasingRequestStageProgressIndex = (
  stage: TRequestStage
): number => {
  if (stage === 'contract') {
    return LEASING_REQUEST_STAGE_ORDER.length;
  }

  const stageIndex = LEASING_REQUEST_STAGE_ORDER.indexOf(stage);

  return stageIndex === -1 ? 0 : stageIndex;
};

export const isLeasingRequestFlowCompleted = (stage: TRequestStage): boolean =>
  stage === 'contract';
